import React, { useState, useEffect } from 'react';
import getProuduct from '../../api/sections.api';
import visitorCount from '../../api/visitor.api';
import { Link } from 'react-router-dom';

const Charger = () => {
    const [productData, setProductData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        getProduct()
    }, [])

    const getProduct = async () => {
        await getProuduct('شواحن', setProductData, setError, setLoading)
        await visitorCount()
    }

    if (loading) return <div className='loader_container'><span className="loader"></span></div>
    if (error) return <div>error....</div>

    return (
        <div className='home'>
            <div className="title">
                <p>الشواحن</p>
            </div>
            <div className="container">
                {productData.map((item) => {
                    return (
                        <div className={`item ${(item.product_images.mainPicURL) == 'not found' ? 'd-none' : null}`} key={item._id}>
                            <Link to={`/details/${item._id}`} >
                            <img src={(item.product_images) != undefined ? item.product_images.mainPicURL : null} alt="product_img" />
                            </Link>
                            <div className='item-cover'>
                                <Link to={`/details/${item._id}`}><p className='product-name'>{item.product_name}</p></Link>
                                <div className='price'>
                                    <p>{`${item.product_price} جنيه`}</p>
                                    <p className={`${(item.product_price_offer) == 1 ? 'd-none' : null}`}>{`${item.product_price_offer} جنيه`}</p>
                                </div>
                                <Link to={`/details/${item._id}`}><button>اطلب الان</button></Link>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default Charger;